// extracted by mini-css-extract-plugin
export var background = "RecentPosts-module--background--a9be6";
export var container = "RecentPosts-module--container--75b4d";
export var root = "RecentPosts-module--root--d8c53";
export var slideCard = "RecentPosts-module--slideCard--8452b";
export var sliderContainer = "RecentPosts-module--sliderContainer--34725";